/**
 * Swedish language translations.
 * Format: {'property': 'translation value';}
 */
export const LANG_SV_SE_TRANS = {
    // menu
    'lvt.menu.twroute': 'Routes',
    'lvt.menu.twcalloff': 'twCalloff',
    'lvt.menu.twslot': 'twSlot',
    'lvt.menu.slot_booking': 'Smart Booking',
    'lvt.menu.twdoc': 'twDoc',
    'lvt.menu.twcost': 'twCost',
    'lvt.menu.lvt': 'Livespårning',
    'lvt.menu.app_name': 'Transwide',
    'lvt.menu.my_profile': 'Min profil',
    'lvt.menu.tw_profile': 'TW-profil',
    'lvt.menu.company_profile': 'Företagsprofil',
    'lvt.menu.my_notifications': 'Mina aviseringar',
    'lvt.menu.sign_out': 'Logga ut',

    // footer
    'lvt.footer.back_to_top': 'Tillbaka till toppen',
    'lvt.footer.terms_of_use': 'Användningsvillkor',
    'lvt.footer.privacy_policy': 'Integritetspolicy',
    'lvt.footer.support_information': 'Supportinformation',
    'lvt.footer.transwide_home': 'Transwide Hem',
    'lvt.footer.license_nr': 'Licensnr.:',
    'lvt.footer.build_version': 'Version:',

    // order list columns
    'lvt.order_list.header': 'Orderlista',
    'lvt.order_list.column.shipperCompany': 'Fraktbolag',
    'lvt.order_list.column.reference': 'Referens',
    'lvt.order_list.column.status': 'Status',
    'lvt.order_list.column.statusReason': 'Statusorsak',
    'lvt.order_list.column.senderCompany': 'Avsändarföretag',
    'lvt.order_list.column.senderZipcode': 'Avsändarens postnummer',
    'lvt.order_list.column.senderCity': 'Avsändarstad',
    'lvt.order_list.column.receiverCompany': 'Mottagarföretag',
    'lvt.order_list.column.receiverZipcode': 'Mottagarens postnummer',
    'lvt.order_list.column.receiverCity': 'Mottagarstad',
    'lvt.order_list.column.carrierName': 'Speditörens namn',
    'lvt.order_list.column.plannedPickupEndDate': 'Planerad upphämtning',
    'lvt.order_list.column.etaPickup': 'Beräknad ankomsttid vid upphämtning',
    'lvt.order_list.column.delayAtPickup': 'Fördröjning vid upphämtning',
    'lvt.order_list.column.plannedDeliveryEndDate': 'Planerad leverans',
    'lvt.order_list.column.etaDelivery': 'Beräknad ankomsttid vid leverans',
    'lvt.order_list.column.delayAtDelivery': 'Fördröjning vid leverans',
    'lvt.order_list.column.timestamps': 'Tidsstämplar',
    'lvt.order_list.column.bookingPickupTime': 'Booking pickup',
    'lvt.order_list.column.bookingDeliveryTime': 'Booking delivery',

    // status order list
    'lvt.order_list.status.requested': 'Begärd',
    'lvt.order_list.status.failed': 'Fel',
    'lvt.order_list.status.waiting': 'Väntar',
    'lvt.order_list.status.active': 'Aktiv',
    'lvt.order_list.status.stopped': 'Fel',
    'lvt.order_list.status.completed': 'Slutförd',
    'lvt.order_list.status.cancelled': 'Avbruten',
    'lvt.order_list.status.timeout': 'Stoppad',

    // status reason order list
    'lvt.order_list.status_reason.carrier_not_assigned': 'Ingen speditör tilldelad',
    'lvt.order_list.status_reason.plate_number_not_present': 'Inget skyltnummer närvarande',
    'lvt.order_list.status_reason.plate_number_not_recognized': 'Inget skyltnummer identifierades',
    'lvt.order_list.status_reason.plate_number_not_operational': 'Skyltnummer används inte',
    'lvt.order_list.status_reason.technical_error_not_posted': 'Technical error when creating the tour in GH',

    // pagination
    'lvt.order_list.pagination.rows_per_page': 'Rader per sida',
    'lvt.order_list.pagination.first': 'Första',
    'lvt.order_list.pagination.previous': 'Föregående',
    'lvt.order_list.pagination.next': 'Nästa',
    'lvt.order_list.pagination.last': 'Sista',
    'lvt.order_list.pagination.no_orders_found': 'Inga ordrar hittades',

    // tracked device
    'lvt.map.tracked_device.trailer': 'Släp',
    'lvt.map.tracked_device.tractor': 'Dragbil',
    'lvt.map.tracked_device.mobile': 'Mobil',

    // map
    'lvt.map.button.open_settings': 'Open settings',
    'lvt.map.button.open_order_list': 'Lista över öppna ordrar',
    'lvt.map.traffic_information.traffic': 'Traffic',
    'lvt.map.traffic_information.fast': 'Fast',
    'lvt.map.traffic_information.slow': 'Slow',
    'lvt.map.pickup_popup.pickup': 'Upphämtning',
    'lvt.map.pickup_popup.date': 'Datum',
    'lvt.map.pickup_popup.address': 'Adress',
    'lvt.map.delivery_popup.delivery': 'Leverans',
    'lvt.map.delivery_popup.date': 'Datum',
    'lvt.map.delivery_popup.address': 'Adress',
    'lvt.map.current_gps_popup.in_transit_to_at_delivery': 'På väg för leverans',
    'lvt.map.current_gps_popup.in_transit_to_at_pickup': 'På väg för upphämtning',
    'lvt.map.current_gps_popup.current_speed': 'Aktuell hastighet',
    'lvt.map.current_gps_popup.average_speed': 'Medelhastighet',
    'lvt.map.current_gps_popup.last_location_update': 'Senaste platsuppdatering',
    'lvt.map.current_gps_popup.eta': 'Beräknad ankomsttid',
    'lvt.map.current_gps_popup.planned_time': 'Planerad tid',
    'lvt.map.current_gps_popup.arrival_delay': 'Ankomstfördröjning',
    'lvt.map.current_gps_popup.speed_unit': 'km/h',

    // timestamps
    'lvt.order_list.timestamp.arrived_at_origin': 'Anlänt till ursprungsplats',
    'lvt.order_list.timestamp.not_arrived_at_origin': 'Ej anlänt till ursprungsplats',
    'lvt.order_list.timestamp.left_origin': 'Lämnat ursprungsplats',
    'lvt.order_list.timestamp.not_left_origin': 'Ej lämnat ursprungsplats',
    'lvt.order_list.timestamp.arrived_at_destination': 'Anlät till destination',
    'lvt.order_list.timestamp.not_arrived_at_destination': 'Ej anlänt till destination',
    'lvt.order_list.timestamp.left_destination': 'Lämnat destination',
    'lvt.order_list.timestamp.not_left_destination': 'Ej lämnat destination',

    // settings
    'lvt.settings.header': 'Settings',
    'lvt.settings.delay_management': 'Delay management',
    'lvt.settings.add_new': 'Add new +',
    'lvt.settings.column.ruleTitle': 'Rule title',
    'lvt.settings.column.type': 'Type',
    'lvt.settings.column.offset': 'Offset',
    'lvt.settings.column.actions': 'Actions',
    'lvt.settings.create_rule': 'Create rule',
    'lvt.settings.view_rule': 'View rule',
    'lvt.settings.go_back_to_list': 'Go back to list',
    'lvt.settings.edit_rule': 'Modify rule',
    'lvt.settings.delete_rule': 'Delete rule',
    'lvt.settings.delete_this_rule': 'Delete this rule',
    'lvt.settings.rule_type.delay': 'Delay',
    'lvt.settings.rule_type.at_risk': 'At risk',
    'lvt.settings.no_rules_found': 'No rules found',
    'lvt.settings.delete_popup.message': 'Are you sure you want to delete this rule?',
    'lvt.settings.field.rule_title': 'Rule title',
    'lvt.settings.field.location_type': 'Location type',
    'lvt.settings.field.location_type_pickup': 'Pickup',
    'lvt.settings.field.location_type_delivery': 'Delivery',
    'lvt.settings.field.rule_type': 'Rule type',
    'lvt.settings.field.rule_type_delay.time_offset': 'Time offset threshold',
    'lvt.settings.field.rule_type_delay.unit_minutes': 'Minutes',
    'lvt.settings.field.rule_type_delay.unit_hours': 'Hours',
    'lvt.settings.field.rule_type_delay.before': 'Before',
    'lvt.settings.field.rule_type_delay.after': 'After',
    'lvt.settings.field.rule_type_atrisk.percentage': 'Percentage threshold',
    'lvt.settings.field.schedule_date_priority': 'Schedule date priority',
    'lvt.settings.field.schedule_date_priority.booking_time': 'Booked timeslot',
    'lvt.settings.field.schedule_date_priority.planned_earliest_arrival': 'Earliest planned arrival',
    'lvt.settings.field.schedule_date_priority.planned_latest_arrival': 'Latest planned arrival',
    'lvt.settings.field.error.required': 'is required',

    // popup
    'lvt.popup.yes': 'Yes',
    'lvt.popup.cancel': 'Cancel',

    // messages from backend
    'lvt.message.info_saved_successfully': 'Info saved successfully.',
    'lvt.message.info_updated_successfully': 'Info updated successfully.',
    'lvt.message.info_deleted_successfully': 'Info deleted successfully.',
    'lvt.message.warn': 'Warning: ',
    'lvt.message.error': 'Error: ',
    'lvt.message.error_no_name_specified': 'No name specified.',
    'lvt.message.error_no_company_id_specified': 'No company Id specified.',
    'lvt.message.error_no_location_type_specified': 'No location type specified.',
    'lvt.message.error_no_rule_type_specified': 'No rule type specified.',
    'lvt.message.error_date_priorities_not_specified': 'Date priorities not specified.',
    'lvt.message.error_delay_offset_not_specified': 'Delay offset not specified.',
    'lvt.message.error_at_risk_offset_not_specified': 'At risk offset not specified.',
    'lvt.message.error_no_entity_found': 'No entity found.',
    'lvt.message.error_could_not_convert_delay_rule': 'Could not convert delay rule.',

    // search
    'lvt.order_list.search': 'Search'
};



// WEBPACK FOOTER //
// ./src/app/services/translation/lang/lang-sv_SE.ts